import React from 'react';
import CropMask from './crop-mask';
import CropGrid from './crop-grid';
import ResizeHandles from './resize-handles';

interface CropOverlayProps {
    cropArea: { x: number; y: number; width: number; height: number };
    cropShape: 'rect' | 'round';
    onCropMouseDown: (e: React.MouseEvent) => void;
    onResizeMouseDown: (corner: 'nw' | 'ne' | 'sw' | 'se') => (e: React.MouseEvent) => void;
}

const CropOverlay: React.FC<CropOverlayProps> = (props) => {
    const {cropArea, cropShape, onCropMouseDown, onResizeMouseDown} = props;

    return (
        <>
            <CropMask
                left={cropArea.x}
                top={cropArea.y}
                width={cropArea.width}
                height={cropArea.height}
                cropShape={cropShape}
            />

            <div
                className={`absolute border-2 border-white cursor-move ${cropShape === 'round' ? 'rounded-full' : ''}`}
                style={{left: cropArea.x, top: cropArea.y, width: cropArea.width, height: cropArea.height}}
                onMouseDown={onCropMouseDown}
            >
                <CropGrid/>
                {cropShape !== 'round' && <ResizeHandles onResizeMouseDown={onResizeMouseDown}/>}
            </div>
        </>
    );
};

export default CropOverlay;
